import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import { CompletedImg } from '~/img';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import features from '~/constants/features';
import theme from '~/constants/theme';

const Completed: FC = () => {
  const { t } = useTranslation('stageResult');

  return (
    <WizardContent
      content={
        <Container className="Completed">
          <div className="Completed-Content">
            <Typography.Title style={{ width: '100%' }} className="Completed-Title">
              {t('Welcome to the Network Family!')}
            </Typography.Title>
            <Typography.Paragraph className="Completed-Paragraph">
              <p>
                <Trans i18nKey="Client is not available based on the details provided by you. Please reach out to commercial card business team at <1>Commercial@network.global</1>">
                  <p>{t('You are all set up. Start using your payment solution today to enjoy the benefits.')}</p>
                  If you wish to discuss any aspects of your services please contact us at
                  <a href="mailto:commercial@network.global" rel="noreferrer" target="_blank">
                    {' Commercial@network.global'}
                  </a>
                </Trans>
              </p>
            </Typography.Paragraph>
            <CompletedImg className="Completed-Img" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .Completed-Content {
    position: relative;
    .Completed-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .Completed-Title {
      position: absolute;
      top: 25%;
      left: 5%;
      width: 30%;
    }
    .Completed-Paragraph {
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .Completed-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Paragraph {
        margin-left: 0;
      }
    }
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .Completed-ContactUs {
      display: none;
    }
  }
`;

export default Completed;
